/**
 * Auth API Service - Portal auth endpoints
 */

import { config } from '../utils/config';

interface AuthApiResponse {
    success: boolean;
    message?: string;
    error?: string;
    data?: any;
}

const getToken = (): string | null => localStorage.getItem('auth_token');

const portalRequest = async (
    endpoint: string,
    method: 'GET' | 'POST' = 'GET',
    body?: Record<string, string>
): Promise<AuthApiResponse> => {
    const token = getToken();
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    try {
        const res = await fetch(`${config.PORTAL_API_URL}${endpoint}`, {
            method,
            headers,
            body: body ? JSON.stringify(body) : undefined,
        });
        const data = await res.json();
        if (!res.ok) {
            return { success: false, error: data.error || data.message || `Error ${res.status}` };
        }
        return { success: true, data: data.data, message: data.message };
    } catch (err: any) {
        return { success: false, error: err.message || 'Network error' };
    }
};

export const setPassword = (newPassword: string) =>
    portalRequest('/api/users/set-password', 'POST', { new_password: newPassword });

export const changePassword = (currentPassword: string, newPassword: string) =>
    portalRequest('/api/users/change-password', 'POST', {
        current_password: currentPassword,
        new_password: newPassword,
    });

export const getMe = () => portalRequest('/api/users/me');
